<template>
  <div style="padding-top: 36px;">
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid">
      <div class="card shadow">
        <div class="card-header">
          <span>Solcitud de crédito</span>
        </div>

        <form @submit.prevent="sendRequest()">
          <div class="form-row" style="margin-top: 24px;">
            <span class="form-label label_first">Cliente</span>
            <div class="form-col" v-if="razonSocial && cardCode">
              <span class="form-label">{{ razonSocial }}</span>
              <span class="form-label"
                ><b>{{ cardCode }}</b></span
              >
            </div>
            <span class="form-label" v-else>Cargando...</span>
          </div>
          <div class="form-row">
            <span class="form-label label_first">Agente de ventas</span>
            <span v-if="agenteVentas" class="form-label">{{
              agenteVentas.SalesEmployeeName
            }}</span>
            <span class="form-label" v-else>Cargando...</span>
          </div>
          <div class="form-row">
            <span class="form-label label_first">Régimen Fiscal</span>
            <span v-if="regimen" class="form-label">{{ regimen.Name }}</span>
            <span class="form-label" v-else>Cargando...</span>
          </div>
          <div class="form-row">
            <span class="form-label label_first">CFDI 4.0</span>
            <span v-if="cfdi" class="form-label">{{ cfdi.name }}</span>
            <span class="form-label" v-else>Cargando...</span>
          </div>

          <hr />
          <div class="form-label-row" style="margin-bottom: 24px; padding: 0px  24px;">
            <div class="form-col_">
              <span class="card-subtitle">
                Completa el siguiente formulario para solicitar Crédito en
                Canplast México
              </span>
              <span class="card-small"
                >Los campos que aparecen con un asterísco (*) son obligatorios.
              </span>
            </div>
            <base-button nativeType="submit" :disabled="loading"
              >Enviar Solicitud</base-button
            >
          </div>
          <hr />
          <div class="form-main-cont">
            <div class="form-col-cont">
              <div class="form-col_">
                <span style="font-weight: 600;" class="form-label label_first"
                  ><b>*</b> Monto solicitado</span
                >
                <input
                  type="Number"
                  v-model="monto"
                  placeholder="Ingresa el monto"
                  class="form-control"
                  min="1"
                  required
                />
              </div>

              <div class="form-col_">
                <span style="font-weight: 600;" class="form-label label_first"
                  ><b>*</b> Constancia Fiscal</span
                >
                <span class="form-label" style="margin-top: -6px; opacity: 0.5;"
                  >Anexa la cédula de identificación fiscal de la empresa.</span
                >

                <vue2-dropzone
                  ref="dzConstFiscal"
                  id="dzConstFiscal"
                  @vdropzone-success="dzSuccess"
                  @vdropzone-max-files-exceeded="
                    dzMaxFiles(files[0].dzId, $event)
                  "
                  :options="files[0].dzOpt"
                  :useCustomSlot="true"
                  class="border rounded"
                  style="width: 100%;"
                >
                  <div class="dropzone-custom-content">
                    <h4 class="dropzone-custom-title">
                      Arrastra y suelta el archivo aquí
                    </h4>
                    <small class="text-muted">
                      ...o haz click para seleccionar el archivo desde tu
                      computadora.
                    </small>
                  </div>
                </vue2-dropzone>
              </div>
              <div class="form-col_">
                <span style="font-weight: 600;" class="form-label label_first"
                  ><b>*</b> Comprobante de domicilio</span
                >
                <span class="form-label" style="margin-top: -6px; opacity: 0.5;"
                  >Anexa un comprobante de domicilio de la razón social qué sea
                  igual a la de tu cédula fiscal.</span
                >
                <vue2-dropzone
                  ref="dzCompDomicilio"
                  id="dzCompDomicilio"
                  @vdropzone-success="dzSuccess"
                  @vdropzone-max-files-exceeded="
                    dzMaxFiles(files[1].dzId, $event)
                  "
                  :options="files[1].dzOpt"
                  :useCustomSlot="true"
                  class="border rounded"
                  style="width: 100%;"
                >
                  <div class="dropzone-custom-content">
                    <h4 class="dropzone-custom-title">
                      Arrastra y suelta el archivo aquí
                    </h4>
                    <small class="text-muted">
                      ...o haz click para seleccionar el archivo desde tu
                      computadora.
                    </small>
                  </div>
                </vue2-dropzone>
              </div>
            </div>
            <div class="form-col-cont">
              <div class="form-col_">
                <span style="font-weight: 600;" class="form-label label_first"
                  ><b>*</b> Plazo</span
                >
                <multiselect
                  v-model="plazo"
                  :options="plazoOptions"
                  placeholder="Selecciona el Plazo"
                  style="z-index: 999;"
                >
                </multiselect>
              </div>
              <div class="form-col_">
                <div class="form-label-row">
                  <span style="font-weight: 600;" class="form-label label_first"
                    ><b>*</b> Solicitud de Canplast</span
                  >
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/canplast-mx.appspot.com/o/customers-web%2FSolicitudCredito.docx?alt=media&token=ab4d6699-b9dc-45f4-8070-5eaab8e7c20b"
                  >
                    <i class="fas fa-arrow-down"></i>
                    Descargar Solicitud
                  </a>
                </div>

                <span class="form-label" style="margin-top: -6px; opacity: 0.5;"
                  >Descarga y llena nuestra Solicitud de Crédito Canplast y
                  anexa a continuación</span
                >
                <vue2-dropzone
                  ref="dzSolicitudCP"
                  id="dzSolicitudCP"
                  @vdropzone-success="dzSuccess"
                  @vdropzone-max-files-exceeded="
                    dzMaxFiles(files[2].dzId, $event)
                  "
                  :options="files[2].dzOpt"
                  :useCustomSlot="true"
                  class="border rounded"
                  style="width: 100%;"
                >
                  <div class="dropzone-custom-content">
                    <h4 class="dropzone-custom-title">
                      Arrastra y suelta el archivo aquí
                    </h4>
                    <small class="text-muted">
                      ...o haz click para seleccionar el archivo desde tu
                      computadora.
                    </small>
                  </div>
                </vue2-dropzone>
              </div>
              <div class="form-col_">
                <span style="font-weight: 600;" class="form-label label_first"
                  ><b>*</b> INE de Representante Legal</span
                >
                <span class="form-label" style="margin-top: -6px; opacity: 0.5;"
                  >Anexa INE de Representante Legal</span
                >
                <vue2-dropzone
                  ref="dzIneRep"
                  id="dzIneRep"
                  @vdropzone-success="dzSuccess"
                  @vdropzone-max-files-exceeded="
                    dzMaxFiles(files[3].dzId, $event)
                  "
                  :options="files[3].dzOpt"
                  :useCustomSlot="true"
                  class="border rounded"
                  style="width: 100%;"
                >
                  <div class="dropzone-custom-content">
                    <h4 class="dropzone-custom-title">
                      Arrastra y suelta el archivo aquí
                    </h4>
                    <small class="text-muted">
                      ...o haz click para seleccionar el archivo desde tu
                      computadora.
                    </small>
                  </div>
                </vue2-dropzone>
              </div>
              <div class="form-col_" style="margin-bottom: 24px;">
                <span style="font-weight: 600;" class="form-label label_first"
                  ><b>*</b> Acta Constitutiva/Poder</span
                >
                <span class="form-label" style="margin-top: -6px; opacity: 0.5;"
                  >Anexa el Acta Constitutiva</span
                >
                <vue2-dropzone
                  ref="dzActaPoder"
                  id="dzActaPoder"
                  @vdropzone-success="dzSuccess"
                  @vdropzone-max-files-exceeded="
                    dzMaxFiles(files[4].dzId, $event)
                  "
                  :options="files[4].dzOpt"
                  :useCustomSlot="true"
                  class="border rounded"
                  style="width: 100%;"
                >
                  <div class="dropzone-custom-content">
                    <h4 class="dropzone-custom-title">
                      Arrastra y suelta el archivo aquí
                    </h4>
                    <small class="text-muted">
                      ...o haz click para seleccionar el archivo desde tu
                      computadora.
                    </small>
                  </div>
                </vue2-dropzone>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  components: {
    vue2Dropzone,
    Multiselect,
  },
  data() {
    return {
      BASE_URL: process.env.VUE_APP_BASE_URL,
      EMAIL_CREDIT: process.env.VUE_APP_EMAIL_CREDIT_REQUEST,
      loading: true,
      cliente: null,
      cfdiOptions: [
        { code: "G01", name: "G01 - Adqusición de mercancias" },
        {
          code: "G02",
          name: "G02 - Devoluciones, descuentos o bonificaciones",
        },
        { code: "G03", name: "G03 - Gastos en general" },
        { code: "I01", name: "I01 - Construcciones" },
        {
          code: "I02",
          name: "I02 - Mobilario y equipo de oficina por inversiones",
        },
        { code: "I03", name: "I03 - Equipo de transporte" },
        { code: "I04", name: "I04 - Equipo de computo y accesorios" },
        {
          code: "I05",
          name: "I05 - Dados, troqueles, moldes, matrices y herramental",
        },
        { code: "I06", name: "I06 - Comunicaciones telefónicas" },
        { code: "I07", name: "I07 - Comunicaciones satelitales" },
        { code: "I08", name: "I08 - Otra maquinaria y equipo" },
        {
          code: "D01",
          name: "D01 - Honorarios médicos, dentales y gastos hospitalarios",
        },
        {
          code: "D02",
          name: "D02 - Gastos médicos por incapacidad o discapacidad",
        },
        { code: "D03", name: "D03 - Gastos funerales" },
        { code: "D04", name: "D04 - Donativos" },
        {
          code: "D05",
          name:
            "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)",
        },
        { code: "D06", name: "D06 - Aportaciones voluntarias al SAR" },
        { code: "D07", name: "D07 - Primas por seguros de gastos médicos" },
        {
          code: "D08",
          name: "D08 - Gastos de transportación escolar obligatoria",
        },
        {
          code: "D09",
          name:
            "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones",
        },
        {
          code: "D10",
          name: "D10 - Pagos por servicios educativos (colegiaturas)",
        },
        { code: "P01", name: "P01 - Por definir" },
      ],
      plazoOptions: [
        "1 día",
        "7 días",
        "15 días",
        "21 días",
        "30 días",
        "40 días",
        "45 días",
        "60 días",
        "80 días",
        "90 días",
      ],
      razonSocial: null,
      cardCode: null,
      agenteVentas: null,
      regimen: null,
      cfdi: null,
      monto: null,
      plazo: null,
      reqNum: 0,
      files: [
        { code: "const_fiscal", dzOpt: {}, link: null, dzId: "dzConstFiscal" },
        {
          code: "comp_domicilio",
          dzOpt: {},
          link: null,
          dzId: "dzCompDomicilio",
        },
        { code: "solicitud_cp", dzOpt: {}, link: null, dzId: "dzSolicitudCP" },
        { code: "ine_rep", dzOpt: {}, link: null, dzId: "dzIneRep" },
        { code: "acta_poder", dzOpt: {}, link: null, dzId: "dzActaPoder" },
      ],
    };
  },
  created() {
    this.files.forEach((x) => {
      x.dzOpt = {
        url: `${this.BASE_URL}/api/credit/upload`,
        uploadMultiple: false,
        maxFiles: 1,
        autoProcessQueue: false,
        addRemoveLinks: true,
        acceptedFiles: "image/jpg,image/jpeg,image/png,application/pdf",
      };
    });
  },
  methods: {
    load() {
      axios
        .all([
          axios.get("/api/business_part/" + localStorage.getItem("rfc")),
          axios.get("/api/sales_persons"),
          axios.get("/api/regimen_fiscal"),
        ])
        .then(
          axios.spread((...responses) => {
            // business_part
            this.cliente = responses[0].data.value[0];
            this.razonSocial = this.cliente.CardName;
            this.cardCode = this.cliente.CardCode;
            var url = `${
              this.BASE_URL
            }/api/business_partners/credit/upload?card_code=${
              this.cardCode
            }&file_type=`;

            this.files.forEach((x) => {
              if (this.$refs[x.dzId]) {
                this.$refs[x.dzId].setOption("url", url + x.code);
                this.$refs[x.dzId].setOption("headers", {
                  Authorization: axios.defaults.headers.common["Authorization"],
                });
              }
            });

            // sales_persons
            this.agenteVentas = responses[1].data.value.find(
              (x) => x.SalesEmployeeCode === this.cliente.SalesPersonCode
            );

            // regimen_fiscal
            this.regimen = responses[2].data.find(
              (x) => x.Code === this.cliente.U_TS_RegFiscal
            );

            // cfdi
            this.cfdi = this.cfdiOptions.find(
              (x) => x.code === this.cliente.U_TS_UsoSN
            );

            this.loading = false;
          })
        );
    },
    sendRequest() {
      if (
        this.$refs.dzConstFiscal.getQueuedFiles().length > 0 &&
        this.$refs.dzCompDomicilio.getQueuedFiles().length > 0 &&
        this.$refs.dzSolicitudCP.getQueuedFiles().length > 0 &&
        this.$refs.dzIneRep.getQueuedFiles().length > 0 &&
        this.$refs.dzActaPoder.getQueuedFiles().length > 0 &&
        this.monto !== null &&
        this.plazo !== null
      ) {
        this.$swal
          .fire({
            text: "¿Deseas enviar la solicitud de crédito?",
            showCancelButton: true,
            confirmButtonText: "Si",
            cancelButtonText: "No",
            icon: "question",
          })
          .then((response) => {
            if (response.isConfirmed) {
              this.files.forEach((x) => {
                this.$refs[x.dzId].processQueue();
              });
            }
          });
      } else {
        this.$swal(
          "",
          "Debes llenar todos los campos para hacer la solicitud",
          "warning"
        );
      }
    },
    dzSuccess(file, response) {
      this.files.every((x) => {
        if (file.xhr.responseURL.includes(x.code)) {
          x.link = response.firebase_url;
          return false;
        } else {
          return true;
        }
      });
      this.reqNum++;
      if (this.reqNum === 5) {
        this.sendMail();
        this.reqNum = 0;
      }
    },
    dzMaxFiles(dzId, file) {
      this.$refs[dzId].removeFile(file);
      this.$swal("", "Solo puedes subir un archivo", "warning");
    },
    sendMail() {
      var json = {
        to: [this.EMAIL_CREDIT],
        replyTo: this.EMAIL_CREDIT,
        email_body: `<b>Hola, ${this.razonSocial} - ${
          this.cardCode
        } ha solicitado un crédito</b><hr>
                         <b>Monto: </b>$${this.monto}<br>
                         <b>Plazo: </b>${this.plazo}<br>
                         <b>Régimen Fiscal: </b>${this.regimen.Name}<br>
                         <b>Uso de CFDI: </b>${this.cfdi.name}<br>
                         <b>Agente: </b>${
                           this.agenteVentas.SalesEmployeeName
                         }<hr>
                         <b>Archivos adjuntos: <br>
                          <a target='_blank' clicktracking="off" href='${
                            this.files[0].link
                          }'>Constancia Fiscal</a><br>
                          <a target='_blank' clicktracking="off" href='${
                            this.files[1].link
                          }'>Comprobante de Domicilio</a><br>
                          <a target='_blank' clicktracking="off" href='${
                            this.files[2].link
                          }'>Formato solicitud de crédito</a><br>
                          <a target='_blank' clicktracking="off" href='${
                            this.files[3].link
                          }'>INE</a><br>
                          <a target='_blank' clicktracking="off" href='${
                            this.files[4].link
                          }'>Acta constitutiva / poder</a><br></b>`,
        subject: `Solicitud de crédito - ${this.cardCode}`,
      };
      axios
        .post("/api/sg/email/send/general", json)
        .then((result) => {
          console.log(
            "🚀 ~ file: SolicitudCredito.vue:420 ~ .then ~ result",
            result
          );
          if (result.data.err) {
            this.$swal("Error", result.data.error.errors[0].message, "error");
          } else {
            this.$swal("", "Tu solicitud ha sido enviada", "success");
            this.files.forEach((x) => {
              this.$refs[x.dzId].removeAllFiles();
              this.monto = null;
              this.plazo = null;
            });
          }
          console.log("Mail", result);
        })
        .catch((error) => {
          this.$swal("Error", error, "error");
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style>
.card {
  min-height: 80vh;
  border-radius: 24px;
  overflow: hidden;
}
.card-header {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  box-sizing: border-box;
  padding: 24px;
  font-size: 18px;
  font-weight: 700;
  background-color: #f6f9fc;
  gap: 16px;
  line-height: 1.1;
}

.card-subtitle {
  font-weight: 400;
  font-size: 16px;
}

.card-small {
  font-size: 14px;
  font-weight: 400;
  color: #f53d57;
  margin-top: -8px;
}

.form-row,
.form-col_ {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 8px 0px;
}

.form-row {
  padding: 8px 36px;
}

.form-col_ {
  align-items: flex-start;
  flex-direction: column;
  align-self: stretch;
  gap: 8px;
}

.form-col_ input,
.form-col_ .multiselect {
  max-height: 40px;
  border-radius: 8px;
  gap: 12px;
  /* max-width: 400px; */
}

.form-label {
  font-size: 14px;
  min-width: 200px;
}

.label_first b {
  color: #f53d57;
}

.form-col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 0px;
}

.form-main-cont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
}

.form-col-cont {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 8px;
  padding: 0px 24px;
}

.form-col-cont:last-of-type {
  padding-left: 0px;
}

.form-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
}

.form-label-row a {
  font-weight: 600;
  color: #f53d57;
}
</style>
